import BasicContentTabItem from './BasicContentTabItem';

export { type BasicContentTabItemProps } from './BasicContentTabItem';
export default BasicContentTabItem;
